
if (isNullOrUndefined(sumo)) {
    throw ('GoogleMapControl.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.maps)) {
    sumo.maps = {};
}

if (isNullOrUndefined(google) || isNullOrUndefined(google.maps)) {
    throw ('GoogleMapControl.js requires Google Maps 3.x found here: https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing,places&sensor=true');
}

function log(aMessage, aDoAppend) {
    "use strict";
    if (aDoAppend) {
        $('#uDebugOutput').text($('#uDebugOutput').text() + ' ' + aMessage);
    } else {
        $('#uDebugOutput').text(aMessage);
    }
}

// ---------------------------------------------------------
// sumo.maps.GoogleMapControl
// ---------------------------------------------------------

// public methods
// --- MAP
//  setCenter()
//  fitBounds()
//  render()
// options
//  optional displayType: satellite, roadmap, hybrid (default)

// --- LAYERS
//  layerAdd(aLayerName, aOptions:
//    {optional renderType = 'marker', 
//    optional doesPlayback = false,
//    optional isVisible = false,
//    optional isClickable = true,
//    optional clickEventHandler = null,
//    optional zIndexStart = 0,
//    optional dataSource = null})
//      aRenderType:
//          'marker'
//          'geometry'
//          'linesegment'
//          'label'
//      aDoesPlayback: if true then the dataset will be played back point by point
//      aIsVisible: if true then the layer will be immediately rendered
//      aDataSource: the dataset that defines the points
//          'marker': dataitem: {latitude, longitude, iconUri, anchor[x,y], data, doHover, hoverHtml, hoverCssClass, hoverVerticalOffset, hoverHorizontalOffset}
//          'geometry': dataitem: { [latitude, longitude], cssClass, hoverHtml, data}
//          'linesegment': dataitem: { segments[latitude, longitude], hoverHtml, data} - sort order matters
//          'label': dataitem: {latitude, longitude, text, cssClass, data, verticalOffset, horizontalOffset} - sort order matters
//  layerRemove(aLayerName)
//  layerShow(aLayerName)
//  layerHide(aLayerName)
//  layerSetDataSource(aLayerName, aDataset)
//  layerSetRenderType(aLayerName, aRenderType)
//      aRenderType:
//          'marker'
//          'geometry'
//          'linesegment'
//          'Label'
//          'label'
//  layerSetDoesPlayback(aLayerName, aDoesPlayback)

//function GoogleMapControl(aId, aParentId, aOptions) {
sumo.maps.GoogleMapControl = function (aId, aParentId, aOptions) {
    "use strict";

    sumo.maps.GoogleMapControl.prototype.baseClass.call(this, aId, aParentId, '<div class="sumo-googlemap" style="width:100%; height:100%" id="##id##"></div>', aOptions);

    var mMap = null,
        mLayers = {},
        mDisplayType = 'hybrid',
        mMapTypeId_OnChange = null,
        mMap_OnClick = null,
        mMap_OnRightClick = null,
        mThis = this,
        mHeatMap = null,
        mHeatMapData = [],
        mGeoSearchThreshold = 15.0,
        mHeatMapGradient = [
       'rgba(0, 255, 255, 0)',
       'rgba(0, 255, 255, 1)',
       'rgba(0, 191, 255, 1)',
       'rgba(0, 127, 255, 1)',
       'rgba(0, 63, 255, 1)',
       'rgba(0, 0, 255, 1)',
       'rgba(0, 0, 223, 1)',
       'rgba(0, 0, 191, 1)',
       'rgba(0, 0, 159, 1)',
       'rgba(0, 0, 127, 1)',
       'rgba(63, 0, 91, 1)',
       'rgba(127, 0, 63, 1)',
       'rgba(191, 0, 31, 1)',
       'rgba(255, 0, 0, 1)'
        ],
        mInfoWindow = null,
        mInfoWindows = [],
        mMultipleInfoWindows = false;
    if (!this.isNothing(aOptions)) {
        if (aOptions.displayType) {
            mDisplayType = aOptions.displayType;
        }
        if (aOptions.mapTypeId_OnChange) {
            mMapTypeId_OnChange = aOptions.mapTypeId_OnChange;
        }
        //Distance Test
        mMap_OnClick = aOptions.OnClick;
        mMap_OnRightClick = aOptions.OnRightClick;
        if (typeof aOptions.multipleInfoWindows === 'boolean') {
            mMultipleInfoWindows = aOptions.multipleInfoWindows;
        }
    }

    

    this.layerAdd = function (aName, aOptions) {
        var lLayer = new sumo.maps.Layer(aName, mMap, aOptions);
        mLayers[aName] = lLayer;
        if (lLayer.isVisible()) {
            lLayer.show();
        }
    };

    this.layerRemove = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.dispose();
            mLayers.splice(mLayers.indexOf(lLayer), 1);
        }
    };

    this.getPlaybackController = function (aLayerName, aOptions) {
        var lKeyLayer = mLayers[aLayerName],
            lSupportLayers = [],
            lKey,
            lLayer,
            lResult = null;
        if (!this.isNothing(lKeyLayer)) {
            for (lKey in mLayers) {
                if (mLayers.hasOwnProperty(lKey)) {
                    lLayer = mLayers[lKey];
                    if (lLayer.doesPlayback() === true && lLayer.name() !== aLayerName) {
                        lSupportLayers.push(lLayer);
                    }
                }
            }
            lResult = new sumo.maps.Playback(lKeyLayer, lSupportLayers, aOptions);
        }
        return lResult;
    };

    this.layerGetShape = function (aLayerName, aShapeId) {
        var lResult = null,
            lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lResult = lLayer.getShape(aShapeId);
        }
        return lResult;
    };

    this.layerShow = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.show();
        }
    };

    this.layerHide = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.hide();
        }
    };

    this.layerSetDataSource = function (aLayerName, aDataSource) {
        var lLayer = mLayers[aLayerName];
        if (mInfoWindow !== null) {
            mInfoWindow.close();
        }
        if (!this.isNothing(lLayer)) {
            lLayer.setDataSource(aDataSource);
        }
    };

    this.layerGetDataSource = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        var lData = [];
        if (!this.isNothing(lLayer)) {
            lData = lLayer.getDataSource();
        }

        return lData;
    };

    this.layerSetRenderType = function (aLayerName, aRenderType) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.setRenderType(aRenderType);
        }
    };

    this.layerSetDragEndHandler = function (aLayerName, aCallback) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.dragEndHandler(aCallback);
        }
    };

    this.layerSetDoesPlayback = function (aLayerName, aDoesPlayback) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            lLayer.setDoesPlayback(aDoesPlayback);
        }
    };
    this.layerGetMarkerById = function (aLayerName, aId) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer)) {
            return lLayer.getMarkerById(aId);
        }
    };

    // Select a marker in a specific layer
    // aLayerName: name of the layer containing the marker
    // aMarker: the marker object or marker identity to select
    // aSelectedIcon: the icon to use for selected state
    this.selectMarker = function (aLayerName, aMarker, aSelectedIcon) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer) && typeof lLayer.selectMarker === 'function') {
            return lLayer.selectMarker(aMarker, aSelectedIcon);
        }
        return null;
    };

    // Deselect the currently selected marker in a specific layer
    // aLayerName: name of the layer
    this.deselectMarker = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer) && typeof lLayer.deselectMarker === 'function') {
            return lLayer.deselectMarker();
        }
        return null;
    };

    // Get the currently selected marker in a specific layer
    // aLayerName: name of the layer
    this.getSelectedMarker = function (aLayerName) {
        var lLayer = mLayers[aLayerName];
        if (!this.isNothing(lLayer) && typeof lLayer.getSelectedMarker === 'function') {
            return lLayer.getSelectedMarker();
        }
        return null;
    };


    this.hideInfo = function () {
        if (mMultipleInfoWindows) {
            mInfoWindows.forEach(function(iw) { if (iw) iw.close(); });
            mInfoWindows = [];
        } else {
            if (mInfoWindow !== null) {
                mInfoWindow.close();
            }
        }
    };

    this.showInfo = function (aAnchor, aHtmlContent, aLatitude, aLongitude) {
        if (mMultipleInfoWindows) {
            var infoWindow = new google.maps.InfoWindow({
                'content': aHtmlContent,
                'position': new google.maps.LatLng(aLatitude, aLongitude),
                'zIndex': 10000000,
                'anchor': aAnchor
            });
            mInfoWindows.push(infoWindow);
            infoWindow.open(mMap, aAnchor);
            // Add event listener to make content selectable
            google.maps.event.addListener(infoWindow, 'domready', function() {
                var lInfoWindowContent = document.querySelector('.gm-style-iw-c');
                if (lInfoWindowContent) {
                    lInfoWindowContent.style.userSelect = 'text';
                    lInfoWindowContent.style.webkitUserSelect = 'text';
                    lInfoWindowContent.style.mozUserSelect = 'text';
                    lInfoWindowContent.style.msUserSelect = 'text';
                }
            });
            // Remove from array when closed
            google.maps.event.addListener(infoWindow, 'closeclick', function() {
                mInfoWindows = mInfoWindows.filter(function(iw) { return iw !== infoWindow; });
            });
        } else {
            if (mInfoWindow !== null) {
                mInfoWindow.close();
            }
            mInfoWindow = new google.maps.InfoWindow({
                'content': aHtmlContent,
                'position': new google.maps.LatLng(aLatitude, aLongitude),
                'zIndex': 10000000,
                'anchor': aAnchor
            });
            window.mInfoWindowGlobal = mInfoWindow;
            var lOriginalClose = mInfoWindow.close;
            mInfoWindow.close = function() {
                lOriginalClose.call(this);
                window.mInfoWindowGlobal = null;
            };
            mInfoWindow.open(mMap, aAnchor);
            google.maps.event.addListener(mInfoWindow, 'domready', function() {
                var lInfoWindowContent = document.querySelector('.gm-style-iw-c');
                if (lInfoWindowContent) {
                    lInfoWindowContent.style.userSelect = 'text';
                    lInfoWindowContent.style.webkitUserSelect = 'text';
                    lInfoWindowContent.style.mozUserSelect = 'text';
                    lInfoWindowContent.style.msUserSelect = 'text';
                }
                var lEscapeKeyHandler = function(e) {
                    if (e.keyCode === 27 && window.mInfoWindowGlobal) {
                        window.mInfoWindowGlobal.close();
                        document.removeEventListener('keydown', lEscapeKeyHandler);
                    }
                };
                document.addEventListener('keydown', lEscapeKeyHandler);
                google.maps.event.addListener(mInfoWindow, 'closeclick', function() {
                    document.removeEventListener('keydown', lEscapeKeyHandler);
                });
            });
        }
    };

    function window_OnResize() {
        if (!mThis.isNothing(mMap)) {
            google.maps.event.trigger(mMap, 'resize');
        }
    }


    this.zoom = function (aLevel) {
        mMap.setZoom(aLevel);
    };

    this.getZoom = function(){
       return mMap.getZoom();
    };

    this.resize = function () {
        window_OnResize();
    }

    this.render = function () {
        var lDisplayType = google.maps.MapTypeId.HYBRID,
            lControlPosition = google.maps.ControlPosition.TOP_RIGHT;
        if (mDisplayType === 'roadmap') {
            lDisplayType = google.maps.MapTypeId.ROADMAP;
        } else if (mDisplayType === 'satellite') {
            lDisplayType = google.maps.MapTypeId.SATELLITE;
        } else if (mDisplayType === 'terrain') {
            lDisplayType = google.maps.MapTypeId.TERRAIN;
        }
        mMap = new google.maps.Map(this.ControlElement[0], {
            'zoom': 3,
            'center': new google.maps.LatLng(27.9709, -82.4646),
            'zoomControl': true,
            'rotateControl': false,
            'zoomControlOptions': {
                position: lControlPosition
            },
            'streetViewControlOptions': {
                position: lControlPosition
            },
            'rotateControlOptions': {
                position: lControlPosition
            },
            'mapTypeId': lDisplayType,
            'styles': [{
                'featureType': 'poi',
                'stylers': [{ visibility: 'on' }]
            }]
        });

        mMap.setTilt(0);

        google.maps.event.addListener(mMap, 'tilt_changed', function () {
            if (mMap.getTilt() !== 0) {
                mMap.setTilt(0);
            }
        });

        google.maps.event.addListener(mMap, 'maptypeid_changed', function () {
            mMap.setTilt(0);
            var lPanorama = mMap.getStreetView();
            if (!mThis.isNothing(mMapTypeId_OnChange) && (mThis.isNothing(lPanorama) || !lPanorama.getVisible())) {
                mMapTypeId_OnChange(mMap);
            }
        });
        //Distance Test
        google.maps.event.addListener(mMap, 'click', function (event) {
            if (!mThis.isNothing(mMap_OnClick)) {
                mMap_OnClick(event);
            }
        });

        google.maps.event.addListener(mMap, "rightclick", function (event) {
            setTimeout(function(){
                if (!mThis.isNothing(mMap_OnRightClick)) {
                    mMap_OnRightClick(event);
                }
            }, 0, event);
            
        });
        mMap.sumoData = this;
        $(window).resize(window_OnResize);

        this.trigger('render');
    };

    this.getMap = function () {
        return mMap;
    };

    this.getCenter = function () {
        var lResult = null;
        if (!this.isNothing(mMap)) {
            lResult = mMap.getCenter();
        }
        return lResult;
    };

    this.setCenter = function (aLatitude, aLongitude) {
        if (!this.isNothing(mMap)) {
            mMap.setCenter(new google.maps.LatLng(aLatitude, aLongitude));
        }
    };

    this.getBoundsFromArray = function (aLatLonArray) {
        var lResult = new google.maps.LatLngBounds(),
            lIndex = 0,
            lLatLng = null,
            lLength = aLatLonArray.length;

        for (lIndex = 0; lIndex < lLength; lIndex++) {
            const point = aLatLonArray[lIndex];
            const lat = point.latitude !== undefined ? point.latitude : point.Latitude;
            const lng = point.longitude !== undefined ? point.longitude : point.Longitude;
            if (lat !== undefined && lng !== undefined) {
                lLatLng = new google.maps.LatLng(lat, lng);
                lResult.extend(lLatLng);
                lLatLng = null;
            }
        }

        return lResult;
    };

    this.fitBounds = function (aLatLngBounds) {
        var lKey,
            lLayer,
            lMapBounds = new google.maps.LatLngBounds();

        if (this.isNothing(aLatLngBounds)) {
            for (lKey in mLayers) {
                if (mLayers.hasOwnProperty(lKey)) {
                    lLayer = mLayers[lKey];
                    if (!this.isNothing(lLayer)) {
                        lMapBounds = lLayer.fitBounds(lMapBounds);
                    }
                }
            }
        } else {
            lMapBounds = aLatLngBounds;
        }
        mMap.fitBounds(lMapBounds);
    };

    function locateResult(aResult, aStatus, aCallback) {
        if (aResult) {
            mThis.setCenter(aResult.center_latitude, aResult.center_longitude);
            if (!mThis.isNothing(aCallback)) {
                aCallback('Geocode', aResult);
            }
        } else {
            if (!mThis.isNothing(aCallback)) {
                aCallback('Geocode', null);
            }
        }
    }
    //TESTING PLACES LIBRARY 
    function placesCallBack(aResults, aStatus) {
        var lPlaceList = [],
            lPlace,
            i;
        if (aStatus === google.maps.places.PlacesServiceStatus.OK) {
            for (i = 0; i < aResults.length; i++) {
                lPlace = aResults[i];
                lPlaceList.push(lPlace);
            }
        }
        switch (mMap.b.id) {
            case 'uOffenderMap':
                enrolleesPlaces_OnComplete(lPlaceList);
                break;
            case 'uEventMap':
                eventsPlaces_OnComplete(lPlaceList);
                break;
            case 'uLiveMap':
                eventsPlaces_OnComplete(lPlaceList);
                break;
            case 'uAnalysisDetailsMap':
                analysisPlaces_OnComplete(lPlaceList);
                break;
            case 'uZoneMap':
                zonesPlaces_OnComplete(lPlaceList);
                break;
        }
    }

    this.latLngLocate = function (aLat, aLng) {
        var geocoder = new google.maps.Geocoder(),
            input = aLat + ',' + aLng,
            latlngStr = input.split(",", 2),
            lat = parseFloat(latlngStr[0]),
            lng = parseFloat(latlngStr[1]),
            latlng = new google.maps.LatLng(lat, lng);
        function OnLocalGeocodeSuccess(aParams, aData) {
            if (!isNullOrUndefined(aData)) {
                return aData.formated_address;
            } else {
                geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (results) {
                            return results.formated_address;
                        }
                    } else {
                        alert("Geocoder failed due to: " + status);
                    }
                });
            }           
        }
        ReverseGeoCodeAddress(aLat, aLng, OnLocalGeocodeSuccess, function () {
            OnLocalGeocodeSuccess(null, [])
        }, { 'latlng': latlng });
    };
   
    this.geocode = function (aAddress, aCallback, aParams) {
        var lGeocoder = new google.maps.Geocoder(),
            latlngStr = aAddress.split(",", 2),
            lat = parseFloat(latlngStr[0]),
            lng = parseFloat(latlngStr[1]),
            latlng = new google.maps.LatLng(lat, lng),
            lRequest = { 'latLng': latlng };

        function success(aResult, aStatus, aResponseType) {
            if (aResult &&  !isNullOrUndefined(aResponseType)) {
                var lAddress = new Address(aResult);
                var latlng1 = { 'lat': aResult.center_latitude, 'lng': aResult.center_longitude };
                var latlng2 = { 'lat': aResult.location.coordinates[0][0][1], 'lng': aResult.location.coordinates[0][0][0]};
                lAddress.Radius = GeodesicDistance(latlng1, latlng2);            
                var lGlobalAddress = new GlobalAddress(lAddress);
                lGlobalAddress.AddressTypeId = 3;
                lGlobalAddress.Name = 'Map Geocode';
                WriteSingle(lGlobalAddress, null, null, null, true);
            }
            aCallback(aResult, aStatus, aParams);
        }

        function OnLocalGeocodeSuccess(aParams, aData) {
            if (!isNullOrUndefined(aData)) {
                success(aData, google.maps.GeocoderStatus.OK, 'LocalGeocode');
               /*  var lResultHits = aData.hits.hits;
                var lLocalResults = formatElasticAddressResults(lResultHits);
                if (lLocalResults == null) {
                    lGeocoder.geocode(lRequest, success);
                } else {
                    success(lLocalResults, google.maps.GeocoderStatus.OK, 'LocalGeocode');
                }   */              
            } else {
                lGeocoder.geocode(lRequest, success);
            }
        }
       
        if (isNaN(latlng.lat())) {
            lRequest = { 'address': aAddress }
        }

        if (!this.isNothing(aAddress)) {
            ReverseGeoCodeAddress(lat, lng, OnLocalGeocodeSuccess, function () {
                OnLocalGeocodeSuccess(null, [])
            }, { 'latlng': latlng });            
        }
    };
    /**
     * Reverse geocode in order to translate a location on the map into a human-readable address
     * @name reverseGeocode
     * @param {string} aLatitude - a Latitude value in String format
     * @param {string} aLongitude - a Longitude  value in String format
     * @param {Function} CallbackCb - Callback function that returns fn(address,status)
    */
    this.reverseGeocode = function(aLatitude,aLongitude,CallbackCb){
        this.geocode(aLatitude + ', ' +  aLongitude
            ,function(address,status,params){
                var list = {};
                if(status === 'OK'){
                    var a = new Address(address);
                    CallbackCb({
                        Description:address.formated_address,
                        Street1: a.StreetNumber + " " + a.Street1,
                        Street2: a.Street2,
                        City: a.City,
                        State: a.State,
                        Zip: a.ZipCode,
                        Country:a.Country
                    },status)
                }else { 
                    CallbackCb({
                        Street1: '',
                        Street2: '',
                        City: '',
                        State: '',
                        Zip: '',
                        Country:'',
                    },status)
                }
            });
        
    }

    // Promise-based reverse geocode for async/await usage
    // Usage: const address = await LiveMapControls.Map.reverseGeocodeAsync(lat, lng);
    // Optional: global alias (window.reverseGeocode) provided below
    this.reverseGeocodeAsync = function(aLatitude, aLongitude) {
        var self = this;
        return new Promise(function(resolve, reject) {
            try {
                self.geocode(aLatitude + ', ' + aLongitude, function(address, status) {
                    try {
                        if (status === 'OK' || status === google.maps.GeocoderStatus.OK) {
                            var a = new Address(address);
                            resolve({
                                Description: address.formated_address,
                                Street1: a.StreetNumber + ' ' + a.Street1,
                                Street2: a.Street2,
                                City: a.City,
                                State: a.State,
                                Zip: a.ZipCode,
                                Country: a.Country
                            });
                        } else {
                            reject(new Error('Reverse geocode failed: ' + status));
                        }
                    } catch (err) {
                        reject(err);
                    }
                });
            } catch (errOuter) {
                reject(errOuter);
            }
        });
    };

    // Provide a convenient global alias for async usage: await reverseGeocode(lat, lng)
    if (typeof window !== 'undefined' && typeof window.reverseGeocode !== 'function') {
        var that = this;
        window.reverseGeocode = function(lat, lng) { return that.reverseGeocodeAsync(lat, lng); };
    }
    this.locate = function (aAddress, aCallback) {
        var lGeocoder = new google.maps.Geocoder(),
            lRequest = { 'address': aAddress },
            lMatch = aAddress.match(/-?\d+\.\d+/g),
            lCallback;

        function OnLocalReverseGeocodeSuccess(aParams, aData) {
            if (!isNullOrUndefined(aData)) {
                locateResult(aData, 'OK', aCallback);
                /* var lResultHits = aData.hits.hits;
                var lGeoResults = formatElasticAddressResults(lResultHits);
                if (lGeoResults == null) {
                    lCallback = function (aResult, aStatus) {
                        locateResult(aResult, aStatus, aCallback);
                    };
                    lGeocoder.geocode(aParams, lCallback);
                } else {
                    locateResult(lGeoResults, 'OK', aCallback);
                }  */               
                
            } else {
                lCallback = function (aResult, aStatus) {
                    locateResult(aResult, aStatus, aCallback);
                };
                lGeocoder.geocode(aParams, lCallback);
            }
            
        }

        if (this.isNothing(lMatch) || lMatch.length !== 2) {           
            GeoCodeAddress(aAddress, OnLocalReverseGeocodeSuccess, function () {
                OnLocalReverseGeocodeSuccess(lRequest, [])
            }, lRequest);
            
        } else {
            this.setCenter(lMatch[0], lMatch[1]);
            if (!isNullOrUndefined(aCallback)) {
                aCallback('LatLong', { 'Latitude': lMatch[0], 'Longitude': lMatch[1] });
            }
        }
    };
    //TESTING PLACES LIBRARY 
    this.locatePlaces = function (aAddress, aCallback) {
        var lRequest,
            lService,
            lMapCenter = mMap.getCenter(),
            lLatitude = lMapCenter.lat(),
            lLongitude = lMapCenter.lng(),
            lLocation = new google.maps.LatLng(lLatitude, lLongitude);


        lRequest = {
            location: lLocation,
            radius: '300',
            query: aAddress
        };
        lService = new google.maps.places.PlacesService(mMap);
        lService.textSearch(lRequest, placesCallBack);
    };

    this.clearStreetView = function () {
        var lPanorama = mMap.getStreetView();

        lPanorama.setVisible(false);
    };

    function navigateToStreetView(aLatLng) {
        var lPanorama;
        lPanorama = mMap.getStreetView();
        lPanorama.setPosition(aLatLng);
        lPanorama.setPov({
            heading: 265,
            pitch: 0
        }
        );
        lPanorama.setVisible(true);
    };

    this.setStreetLevel = function (aLatitude, aLongitude, aPlaceMarker) {
        var lStreetViewService = new google.maps.StreetViewService(),
            lStreetViewMaxDistance = 100,
            lLatLng = new google.maps.LatLng(aLatitude, aLongitude),
            lPanorama,
            lMessage;

        if (aPlaceMarker) {
            var marker = new google.maps.Marker({
                position: lLatLng,
                map: mMap,
                icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            });
        }    

        lStreetViewService.getPanoramaByLocation(lLatLng, lStreetViewMaxDistance, function (aStreetViewPanoramaData, aStatus) {
            if (aStatus === google.maps.StreetViewStatus.OK) {
                navigateToStreetView(aStreetViewPanoramaData.location.latLng);
            } else {
                mThis.trigger('streetviewerror', 'Street View Unavailable');
                lPanorama = mMap.getStreetView();
                lPanorama.setVisible(false);
            }
        });
    };

    this.boundsChanged = function () {
        google.maps.event.trigger(mMap, 'resize');
        //        google.maps.event.trigger(mMap, 'bounds_changed');
        //        google.maps.event.trigger(mMap, 'projection_changed');
    };
    this.isLayerNotAvailable = function(aLayerName){
        return this.isNothing(mLayers[aLayerName])
    }
    this.dispose = function () {
        var lKey = null,
            lLayer = null;

        if (mMultipleInfoWindows) {
            mInfoWindows.forEach(function(iw) { if (iw) iw.close(); });
            mInfoWindows = [];
        } else {
            if (mInfoWindow !== null) {
                mInfoWindow.close();
            }
        }
        for (lKey in mLayers) {
            if (mLayers.hasOwnProperty(lKey)) {
                lLayer = mLayers[lKey];
                if (!this.isNothing(lLayer)) {
                    lLayer.dispose();
                    mLayers[lKey] = null;
                }
            }
        }
        mLayers = null;

        $(window).unbind('resize', window_OnResize);
        google.maps.event.clearListeners(mMap);
        mMap = null;

        mThis = null;
        sumo.maps.GoogleMapControl.prototype.dispose.call(this);
    };

    this.getHeatMapDataPoints = function () {
        return mHeatMapData;
    };

    this.setHeatMapDataPoints = function (aDataSet) {
        mHeatMapData = [];
        if (aDataSet != null) {
            for (var key in aDataSet) {
                if (aDataSet.hasOwnProperty(key)) {                    
                    mHeatMapData.push(new google.maps.LatLng(aDataSet[key].Latitude, aDataSet[key].Longitude));
                }                
            }           
        }

        if (!isNullOrUndefined(mHeatMap)) {
            mHeatMap.set('data', mHeatMapData);
        }
        
    };

    this.changeHeatMapGradient = function () {       
        mHeatMap.set('gradient', mHeatMap.get('gradient') ? null : mHeatMapGradient);
    };

    this.getHeatMap = function () {
        return mHeatMap;
    };

    this.toggleHeatMap = function () {
        if (mHeatMap == null) {
            mHeatMap = new google.maps.visualization.HeatmapLayer({
                data: mHeatMapData,
                map: mMap
            });

            mHeatMap.set('gradient', mHeatMap.get('gradient') ? null : mHeatMapGradient);
            
        } else {
            mHeatMapData = [];
            mHeatMap.setMap(null);
            mHeatMap = null;
        }
    };

    this.changeRadius = function (aRadius) {
        mHeatMap.set('radius', mHeatMap.get('radius') ? null : aRadius);
    };

    this.disposeHeatMap = function () {
        mHeatMapData = [];
        if (mHeatMap != null) {
            mHeatMap.setMap(null);
            mHeatMap = null;
        }
       
    };

    this.changeOpacity = function (aOpacity) {
        mHeatMap.set('opacity', mHeatMap.get('opacity') ? null : aOpacity);
    };

    // ---------------------------------------------------------
    // Custom Popup Logic
    // ---------------------------------------------------------
    
    // Popup configuration constants
    var POPUP_ZINDEX = 10000001,
        POPUP_CONNECTOR_ZINDEX = 10000000,
        POPUP_MIN_WIDTH = 180,
        POPUP_MAX_WIDTH = 350,
        POPUP_MAX_HEIGHT = 300,
        POPUP_MARKER_OFFSET = 45,
        POPUP_POSITION_RETRY_DELAY = 50,
        POPUP_INITIAL_POSITION_DELAY = 10,
        POPUP_COORD_TOLERANCE = 0.000001,
        POPUP_CONNECTOR_COLOR = '#B83692',
        POPUP_CONNECTOR_STROKE_WIDTH = 2,
        POPUP_CONNECTOR_CIRCLE_RADIUS = 6;

    // Module-level popup tracking
    var mPopupDivs = [],
        mPopupEscapeHandler = null;

    // Maximum number of open popups allowed
    var MAX_OPEN_POPUPS = 5;

    /**
     * Helper to compare coordinates with tolerance for floating point precision
     * @param {number} aLat1 - First latitude
     * @param {number} aLng1 - First longitude
     * @param {number} aLat2 - Second latitude
     * @param {number} aLng2 - Second longitude
     * @returns {boolean} True if coordinates match within tolerance
     */
    function coordsMatch(aLat1, aLng1, aLat2, aLng2) {
        return Math.abs(aLat1 - aLat2) < POPUP_COORD_TOLERANCE && 
               Math.abs(aLng1 - aLng2) < POPUP_COORD_TOLERANCE;
    }

    /**
     * Setup single shared escape key handler for all popups
     */
    function popup_EnsureEscapeHandler() {
        if (mPopupEscapeHandler) {
            return;
        }
        mPopupEscapeHandler = function (e) {
            if (e.keyCode === 27 && mPopupDivs.length > 0) {
                mPopupDivs.slice().forEach(function (lDiv) {
                    if (lDiv._close && !lDiv._closed) {
                        lDiv._close();
                    }
                });
            }
        };
        document.addEventListener('keydown', mPopupEscapeHandler);
    }

    /**
     * Remove escape handler when no popups are open
     */
    function popup_RemoveEscapeHandlerIfEmpty() {
        if (mPopupDivs.length === 0 && mPopupEscapeHandler) {
            document.removeEventListener('keydown', mPopupEscapeHandler);
            mPopupEscapeHandler = null;
        }
    }

    /**
     * Apply base styles to popup container element
     * @param {HTMLElement} aElement - The popup element
     */
    function popup_ApplyContainerStyles(aElement) {
        aElement.style.position = 'absolute';
        aElement.style.zIndex = POPUP_ZINDEX;
        aElement.style.background = 'white';
        aElement.style.border = '1px solid #888';
        aElement.style.borderRadius = '4px';
        aElement.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
        aElement.style.minWidth = POPUP_MIN_WIDTH + 'px';
        aElement.style.maxWidth = POPUP_MAX_WIDTH + 'px';
        aElement.style.userSelect = 'text';
        aElement.style.webkitUserSelect = 'text';
        aElement.style.visibility = 'hidden';
    }

    /**
     * Apply styles to drag handle header element
     * @param {HTMLElement} aElement - The header element
     */
    function popup_ApplyHeaderStyles(aElement) {
        aElement.style.cursor = 'move';
        aElement.style.background = '#f0f0f0';
        aElement.style.borderBottom = '1px solid #ccc';
        aElement.style.borderRadius = '4px 4px 0 0';
        aElement.style.padding = '6px 30px 6px 10px';
        aElement.style.position = 'relative';
        aElement.style.height = '20px';
    }

    /**
     * Apply styles to close button element
     * @param {HTMLElement} aElement - The close button element
     */
    function popup_ApplyCloseButtonStyles(aElement) {
        aElement.style.cursor = 'pointer';
        aElement.style.position = 'absolute';
        aElement.style.top = '5px';
        aElement.style.right = '10px';
        aElement.style.fontSize = '20px';
        aElement.style.color = '#666';
        aElement.style.lineHeight = '20px';
        aElement.style.fontWeight = 'bold';
    }

    /**
     * Apply styles to content area element
     * @param {HTMLElement} aElement - The content element
     */
    function popup_ApplyContentStyles(aElement) {
        aElement.style.padding = '10px';
        aElement.style.maxHeight = POPUP_MAX_HEIGHT + 'px';
        aElement.style.overflowY = 'auto';
    }

    /**
     * Apply styles to caret (triangle pointer) element
     * @param {HTMLElement} aElement - The caret element
     */
    function popup_ApplyCaretStyles(aElement) {
        aElement.style.position = 'absolute';
        aElement.style.left = '50%';
        aElement.style.transform = 'translateX(-50%)';
        aElement.style.bottom = '-10px';
        aElement.style.width = '0';
        aElement.style.height = '0';
        aElement.style.borderLeft = '10px solid transparent';
        aElement.style.borderRight = '10px solid transparent';
        aElement.style.borderTop = '10px solid white';
    }

    /**
     * Apply styles to connector SVG element
     * @param {SVGElement} aElement - The SVG element
     */
    function popup_ApplyConnectorSvgStyles(aElement) {
        aElement.style.position = 'absolute';
        aElement.style.pointerEvents = 'none';
        aElement.style.overflow = 'visible';
        aElement.style.left = '0';
        aElement.style.top = '0';
        aElement.style.width = '100%';
        aElement.style.height = '100%';
        aElement.style.zIndex = POPUP_CONNECTOR_ZINDEX;
        aElement.style.display = 'none';
    }

    /**
     * Calculate pixel position from lat/lng coordinates
     * @param {number} aLatitude - Latitude coordinate
     * @param {number} aLongitude - Longitude coordinate
     * @returns {Object|null} Object with x,y pixel coordinates or null if unavailable
     */
    function popup_CalculatePixelPosition(aLatitude, aLongitude) {
        var lBounds = mMap.getBounds(),
            lProjection = mMap.getProjection(),
            lScale,
            lNorthWest,
            lWorldCoordinateNW,
            lWorldCoordinate;

        if (mThis.isNothing(lBounds) || mThis.isNothing(lProjection)) {
            return null;
        }

        lScale = Math.pow(2, mMap.getZoom());
        lNorthWest = new google.maps.LatLng(
            lBounds.getNorthEast().lat(),
            lBounds.getSouthWest().lng()
        );
        lWorldCoordinateNW = lProjection.fromLatLngToPoint(lNorthWest);
        lWorldCoordinate = lProjection.fromLatLngToPoint(
            new google.maps.LatLng(aLatitude, aLongitude)
        );

        return {
            x: Math.floor((lWorldCoordinate.x - lWorldCoordinateNW.x) * lScale),
            y: Math.floor((lWorldCoordinate.y - lWorldCoordinateNW.y) * lScale)
        };
    }

    /**
     * Show a custom draggable popup at a given lat/lng with HTML content.
     * The popup can be dragged by its header bar and will show a connector
     * line to the marker when dragged away from its original position.
     * @name showPopup
     * @param {string} aHtmlContent - HTML content to display in the popup
     * @param {number} aLatitude - Latitude coordinate for popup position
     * @param {number} aLongitude - Longitude coordinate for popup position
     * @returns {HTMLElement|null} The popup div element for reference, or null if map not ready
     */

    this.showPopup = function (aHtmlContent, aLatitude, aLongitude) {
        // Validate map is available
        if (mThis.isNothing(mMap)) {
            return null;
        }

        // Enforce max open popups limit (show message only when trying to open the 6th)
        var openPopupsCount = mPopupDivs.filter(function (lDiv) { return !lDiv._closed; }).length;
        if (openPopupsCount >= MAX_OPEN_POPUPS) {
            if (typeof window !== 'undefined' && window.mActivityNotification && typeof window.mActivityNotification.addNotification === 'function' && typeof window.localizeWrapper === 'function' && openPopupsCount === MAX_OPEN_POPUPS) {
                var maxCardsTitle = window.localizeWrapper('cMaximumCardsOpen') || 'Maximum Cards Open';
                var maxCardsMsg = window.localizeWrapper('cMaximumCardsOpenMsg') || 'You have reached the limit of 5 opened cards. Please close one of the existing cards to open another.';
                mActivityNotification.clearNotifications();
                window.mActivityNotification.addNotification(maxCardsTitle + '<br>' + maxCardsMsg);
            }
            return null;
        }

        // Local variables - declared at top per project style
        var lMapContainer = mMap.getDiv(),
            lPopupDiv = null,
            lDragHandle = null,
            lCloseBtn = null,
            lContentDiv = null,
            lCaret = null,
            lConnectorSvg = null,
            lConnectorLine = null,
            lConnectorCircle = null,
            lBoundsListener = null,
            lHasBeenDragged = false,
            lManualLeft = 0,
            lManualTop = 0,
            lIsDragging = false,
            lDragStartX = 0,
            lDragStartY = 0,
            lPopupStartLeft = 0,
            lPopupStartTop = 0;

        // Close any existing popup at the same location to prevent duplicates
        mPopupDivs.slice().forEach(function (lDiv) {
            if (!lDiv._closed && coordsMatch(lDiv._lat, lDiv._lng, aLatitude, aLongitude)) {
                if (lDiv._close) {
                    lDiv._close();
                }
            }
        });

        // Create popup container
        lPopupDiv = document.createElement('div');
        lPopupDiv.className = 'gm-custom-popup';
        popup_ApplyContainerStyles(lPopupDiv);

        // Create drag handle header bar
        lDragHandle = document.createElement('div');
        lDragHandle.className = 'gm-popup-header';
        popup_ApplyHeaderStyles(lDragHandle);
        lPopupDiv.appendChild(lDragHandle);

        // Create close button
        lCloseBtn = document.createElement('span');
        lCloseBtn.className = 'gm-popup-close';
        lCloseBtn.innerHTML = '&times;';
        popup_ApplyCloseButtonStyles(lCloseBtn);
        lCloseBtn.onmouseover = function () { lCloseBtn.style.color = '#000'; };
        lCloseBtn.onmouseout = function () { lCloseBtn.style.color = '#666'; };
        lDragHandle.appendChild(lCloseBtn);

        // Create content area
        lContentDiv = document.createElement('div');
        lContentDiv.className = 'gm-popup-content';
        popup_ApplyContentStyles(lContentDiv);
        lContentDiv.innerHTML = aHtmlContent;
        lPopupDiv.appendChild(lContentDiv);

        // Create caret (downward triangle pointer)
        lCaret = document.createElement('div');
        lCaret.className = 'gm-popup-caret';
        popup_ApplyCaretStyles(lCaret);
        lPopupDiv.appendChild(lCaret);

        // Create connector SVG (shown when popup is dragged away from marker)
        lConnectorSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        popup_ApplyConnectorSvgStyles(lConnectorSvg);

        lConnectorLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        lConnectorLine.setAttribute('stroke', POPUP_CONNECTOR_COLOR);
        lConnectorLine.setAttribute('stroke-width', POPUP_CONNECTOR_STROKE_WIDTH);
        lConnectorLine.setAttribute('stroke-dasharray', '5,5');

        lConnectorCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        lConnectorCircle.setAttribute('r', POPUP_CONNECTOR_CIRCLE_RADIUS);
        lConnectorCircle.setAttribute('fill', POPUP_CONNECTOR_COLOR);
        lConnectorCircle.setAttribute('stroke', 'white');
        lConnectorCircle.setAttribute('stroke-width', POPUP_CONNECTOR_STROKE_WIDTH);

        lConnectorSvg.appendChild(lConnectorLine);
        lConnectorSvg.appendChild(lConnectorCircle);
        lMapContainer.appendChild(lConnectorSvg);

        /**
         * Update connector line position between popup and marker
         */
        function updateConnector() {
            var lPixelPos = null,
                lPopupLeft = 0,
                lPopupTop = 0,
                lPopupWidth = 0,
                lPopupHeight = 0,
                lPopupCenterX = 0,
                lPopupBottomY = 0;

            if (!lHasBeenDragged || lPopupDiv._closed) {
                lConnectorSvg.style.display = 'none';
                return;
            }

            lPixelPos = popup_CalculatePixelPosition(aLatitude, aLongitude);
            if (mThis.isNothing(lPixelPos)) {
                lConnectorSvg.style.display = 'none';
                return;
            }

            // Get popup center bottom position
            lPopupLeft = parseInt(lPopupDiv.style.left, 10) || 0;
            lPopupTop = parseInt(lPopupDiv.style.top, 10) || 0;
            lPopupWidth = lPopupDiv.offsetWidth || POPUP_MIN_WIDTH;
            lPopupHeight = lPopupDiv.offsetHeight || 100;
            lPopupCenterX = lPopupLeft + lPopupWidth / 2;
            lPopupBottomY = lPopupTop + lPopupHeight;

            // Update line coordinates
            lConnectorLine.setAttribute('x1', lPopupCenterX);
            lConnectorLine.setAttribute('y1', lPopupBottomY);
            lConnectorLine.setAttribute('x2', lPixelPos.x);
            lConnectorLine.setAttribute('y2', lPixelPos.y);

            // Update circle position at marker
            lConnectorCircle.setAttribute('cx', lPixelPos.x);
            lConnectorCircle.setAttribute('cy', lPixelPos.y);

            lConnectorSvg.style.display = 'block';
        }

        /**
         * Position popup based on lat/lng coordinates
         */
        function positionPopup() {
            var lPixelPos = null,
                lPopupWidth = 0,
                lPopupHeight = 0;

            if (lHasBeenDragged || lPopupDiv._closed) {
                if (!lPopupDiv._closed) {
                    lPopupDiv.style.left = lManualLeft + 'px';
                    lPopupDiv.style.top = lManualTop + 'px';
                }
                return;
            }

            lPixelPos = popup_CalculatePixelPosition(aLatitude, aLongitude);

            // Wait for map to be ready
            if (mThis.isNothing(lPixelPos)) {
                setTimeout(positionPopup, POPUP_POSITION_RETRY_DELAY);
                return;
            }

            // Center popup above the marker
            lPopupWidth = lPopupDiv.offsetWidth || POPUP_MIN_WIDTH;
            lPopupHeight = lPopupDiv.offsetHeight || 100;

            lPopupDiv.style.left = (lPixelPos.x - lPopupWidth / 2) + 'px';
            lPopupDiv.style.top = (lPixelPos.y - lPopupHeight - POPUP_MARKER_OFFSET) + 'px';
            lPopupDiv.style.visibility = 'visible';
            lCaret.style.display = 'block';
        }

        /**
         * Handle drag move event
         * @param {MouseEvent} e - Mouse event
         */
        function popup_OnDragMove(e) {
            var lDeltaX = 0,
                lDeltaY = 0;

            if (!lIsDragging) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            lDeltaX = e.clientX - lDragStartX;
            lDeltaY = e.clientY - lDragStartY;

            lManualLeft = lPopupStartLeft + lDeltaX;
            lManualTop = lPopupStartTop + lDeltaY;

            lPopupDiv.style.left = lManualLeft + 'px';
            lPopupDiv.style.top = lManualTop + 'px';

            updateConnector();
        }

        /**
         * Handle drag end event
         */
        function popup_OnDragEnd() {
            if (!lIsDragging) {
                return;
            }
            lIsDragging = false;
            lHasBeenDragged = true;
            lPopupDiv._dragged = true; // Expose dragged state on element
            lCaret.style.display = 'none';
            updateConnector();

            document.removeEventListener('mousemove', popup_OnDragMove, true);
            document.removeEventListener('mouseup', popup_OnDragEnd, true);

            // Re-enable map dragging
            if (!mThis.isNothing(mMap)) {
                mMap.setOptions({ draggable: true });
            }
        }

        /**
         * Handle drag start event on header
         * @param {MouseEvent} e - Mouse event
         */
        function popup_OnDragStart(e) {
            if (e.target === lCloseBtn) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            lIsDragging = true;
            lDragStartX = e.clientX;
            lDragStartY = e.clientY;
            lPopupStartLeft = parseInt(lPopupDiv.style.left, 10) || 0;
            lPopupStartTop = parseInt(lPopupDiv.style.top, 10) || 0;

            // Disable map dragging while dragging popup
            if (!mThis.isNothing(mMap)) {
                mMap.setOptions({ draggable: false });
            }

            document.addEventListener('mousemove', popup_OnDragMove, true);
            document.addEventListener('mouseup', popup_OnDragEnd, true);
        }

        /**
         * Close popup and clean up resources (with double-close protection)
         */
        function closePopup() {
            var lIndex = -1;

            if (lPopupDiv._closed) {
                return;
            }
            lPopupDiv._closed = true;

            // Remove bounds listener
            if (!mThis.isNothing(lBoundsListener)) {
                google.maps.event.removeListener(lBoundsListener);
                lBoundsListener = null;
            }

            // Remove connector SVG from DOM
            if (!mThis.isNothing(lConnectorSvg) && !mThis.isNothing(lConnectorSvg.parentNode)) {
                lConnectorSvg.parentNode.removeChild(lConnectorSvg);
            }

            // Remove popup from DOM
            if (!mThis.isNothing(lPopupDiv.parentNode)) {
                lPopupDiv.parentNode.removeChild(lPopupDiv);
            }

            // Remove from tracking array
            lIndex = mPopupDivs.indexOf(lPopupDiv);
            if (lIndex !== -1) {
                mPopupDivs.splice(lIndex, 1);
            }

            // Clean up escape handler if no more popups
            popup_RemoveEscapeHandlerIfEmpty();

            // Ensure map dragging is re-enabled
            if (!mThis.isNothing(mMap)) {
                mMap.setOptions({ draggable: true });
            }
        }

        // Append popup to map container
        lMapContainer.appendChild(lPopupDiv);

        // Store coordinates and state on element
        lPopupDiv._lat = aLatitude;
        lPopupDiv._lng = aLongitude;
        lPopupDiv._closed = false;
        lPopupDiv._dragged = false;
        lPopupDiv._close = closePopup;

        // Add to tracking array
        mPopupDivs.push(lPopupDiv);

        // Ensure escape handler is active
        popup_EnsureEscapeHandler();

        // Initial positioning (with slight delay to ensure popup is rendered)
        setTimeout(positionPopup, POPUP_INITIAL_POSITION_DELAY);

        // Update position when map moves (only if not manually dragged)
        lBoundsListener = google.maps.event.addListener(mMap, 'bounds_changed', function () {
            if (!lPopupDiv._closed) {
                positionPopup();
                updateConnector();
            }
        });
        lPopupDiv._boundsListener = lBoundsListener;

        // Attach drag event handlers
        lDragHandle.addEventListener('mousedown', popup_OnDragStart);

        // Prevent clicks inside popup from propagating to map
        lPopupDiv.addEventListener('mousedown', function (e) { e.stopPropagation(); });
        lPopupDiv.addEventListener('click', function (e) { e.stopPropagation(); });
        lPopupDiv.addEventListener('dblclick', function (e) { e.stopPropagation(); });

        // Attach close button handler
        lCloseBtn.onclick = function (e) {
            e.stopPropagation();
            closePopup();
        };

        return lPopupDiv;
    };

    /**
     * Hide/close all custom popups currently displayed on the map
     * @name hidePopup
     */
    this.hidePopup = function () {
        mPopupDivs.slice().forEach(function (lDiv) {
            if (lDiv._close && !lDiv._closed) {
                lDiv._close();
            }
        });
        mPopupDivs = [];
        popup_RemoveEscapeHandlerIfEmpty();
    };

    /**
     * Hide/close only unpinned popups.
     * Pinned popups (dragged by user) are kept open.
     * @name hideUnpinnedPopups
     */
    this.hideUnpinnedPopups = function () {
        mPopupDivs.slice().forEach(function (lDiv) {
            if (lDiv._close && !lDiv._closed && !lDiv._dragged) {
                lDiv._close();
            }
        });
        popup_RemoveEscapeHandlerIfEmpty();
    };

    /**
     * Hide/close a specific popup by its coordinates
     * @name hidePopupAt
     * @param {number} aLatitude - Latitude coordinate of the popup to close
     * @param {number} aLongitude - Longitude coordinate of the popup to close
     * @returns {boolean} True if a popup was closed, false otherwise
     */
    this.hidePopupAt = function (aLatitude, aLongitude) {
        var lFound = false;

        mPopupDivs.slice().forEach(function (lDiv) {
            if (!lDiv._closed && coordsMatch(lDiv._lat, lDiv._lng, aLatitude, aLongitude)) {
                if (lDiv._close) {
                    lDiv._close();
                    lFound = true;
                }
            }
        });

        return lFound;
    };

    /**
     * Close a specific popup by reference (as returned from showPopup)
     * @name closePopup
     * @param {HTMLElement} aPopupRef - Reference to the popup element to close
     * @returns {boolean} True if popup was closed, false otherwise
     */
    this.closePopup = function (aPopupRef) {
        if (!mThis.isNothing(aPopupRef) && !aPopupRef._closed && typeof aPopupRef._close === 'function') {
            aPopupRef._close();
            return true;
        }
        return false;
    };

    /**
     * Get count of currently open popups
     * @name getPopupCount
     * @returns {number} Number of open popups
     */
    this.getPopupCount = function () {
        return mPopupDivs.filter(function (lDiv) { 
            return !lDiv._closed; 
        }).length;
    };

    this.render();
};
sumo.maps.GoogleMapControl.prototype = new sumo.controls.ControlBase();
sumo.maps.GoogleMapControl.prototype.constructor = sumo.maps.GoogleMapControl;
sumo.maps.GoogleMapControl.prototype.baseClass = sumo.controls.ControlBase;